import TextField from "@mui/material/TextField";
const NumberInput = ({
  name,
  label,
  value,
  onChange,
  required = false,
  slotProps = {},
  max,
  ...props
}) => {

  const handleChange = (e) => {
    let newValue = e.target.value;
    if (!/^\d*\.?\d*$/.test(newValue)) return;
    const numericValue = parseFloat(newValue);
    if (!isNaN(numericValue) && numericValue > max) return;
    onChange({ target: { name, value: newValue } });
  };
  return (
    <TextField
      name={name}
      label={label}
      type="text"
      size="small"
      value={value}
      onChange={handleChange}
      onBeforeInput={(e) => {
        if (!/^\d*\.?\d*$/.test(e.data)) {
          e.preventDefault();
        }
      }}
      slotProps={{
        input: {
          inputMode: "decimal",
          pattern: "[0-9]*[.]?[0-9]*",
          ...slotProps.input,
        },
      }}
      required={required}
      {...props}
    />
  );
};
export default NumberInput;